module.exports = __webpack_public_path__ + "static/media/platinum.12fca745.png";